import { inject, Injectable } from '@angular/core';
import { ConsentForm, FormStatus } from '@models';
import { catchError, map, Observable, of, switchMap } from 'rxjs';
import { CONSENT_FORMS_SERVICE } from '../tokens/consent-forms.token';
import { ConsentFormService } from './consent-forms/consent-form.service';

@Injectable({
  providedIn: 'root',
})
export class AppointmentConsentCompletionService {
  private readonly consentFormsService = inject(CONSENT_FORMS_SERVICE);
  private readonly consentFormService = inject(ConsentFormService);

  signConsentForAppointment(appointmentId: string): Observable<boolean> {
    return this.consentFormsService
      .getSubmissionByAppointmentId(appointmentId)
      .pipe(
        catchError(() => of<ConsentForm[]>([])),
        map(submissions =>
          (submissions ?? [])
            .filter(({ status }) => status !== FormStatus.Completed)
            .map(({ id }) => id)
        ),
        switchMap(pendingIds =>
          pendingIds.length
            ? this.consentFormService.openSignSequence(pendingIds)
            : of(true)
        )
      );
  }
}
